
import type { BaseErrorResponse, GetCurrenciesRatesRes, GetCurrenciesRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useCurrencies() {
  class Currencies<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * @description Returns a list of currency
     *
     * @tags Currency
     * @name CurrenciesControllerGetCurrencies
     * @summary Getting a list of currency
     * @request GET:/api3/currencies
     * @deprecated
     * @secure
     * @response `200` `GetCurrenciesRes`
     * @response `400` `BaseErrorResponse`
     */
    currenciesControllerGetCurrencies = (
      query?: {
        /**
         * Including a rate in response
         * @example true
         */
        with_rates?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCurrenciesRes, BaseErrorResponse>({
        path: '/api3/currencies',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * @description Returns a list of currency rates
     *
     * @tags Currency
     * @name CurrenciesControllerGetCurrenciesRates
     * @summary Getting currency rates
     * @request GET:/api3/currencies/rates
     * @deprecated
     * @secure
     * @response `200` `GetCurrenciesRatesRes`
     * @response `400` `BaseErrorResponse`
     */
    currenciesControllerGetCurrenciesRates = (params: RequestParams = {}) =>
      this.request<GetCurrenciesRatesRes, BaseErrorResponse>({
        path: '/api3/currencies/rates',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Currencies();
}
